import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.setPin();
    }

    setPin() {
        ScrollTrigger.create({
            trigger: ".history__bg",
            endTrigger: ".history",
            start: "top top",
            end: "bottom bottom",
            pin: true,
        });

        //moreボタンでのアップデート
        [...document.querySelectorAll(".js-moretrigger")].forEach((el) => {
            el.addEventListener("click", () => {
                setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 500);
            });
        });

        //アコーディオンでのアップデート
        [...document.querySelectorAll(".js-acc_trigger")].forEach((el) => {
            el.addEventListener("click", (e) => {
                //アコーディオン完了後にページ高さをリフレッシュ
                setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 500);
            });
        });
    }
}
